import { ConfigurationToolbar as SharedConfigurationToolbar } from "../../components/configuration-toolbar.component";
import type { AsyncStatus } from "../../components/types";

type GeneralConfigurationToolbarProps = {
  applyingChangesACKStatus: AsyncStatus;
  onViewHistory: () => void;
  onRestore: () => void;
  onApplyChanges: () => void;
  applyChangesCountdown?: number;
};

export function ConfigurationToolbar({
  applyingChangesACKStatus,
  onViewHistory,
  onRestore,
  onApplyChanges,
  applyChangesCountdown,
}: GeneralConfigurationToolbarProps) {
  return (
    <SharedConfigurationToolbar
      title="General Configuration"
      subtitle="Manage operational parameters."
      showViewHistory
      showRestore
      showApplyChanges
      applyingChangesACKStatus={applyingChangesACKStatus}
      applyChangesCountdown={applyChangesCountdown}
      onViewHistory={onViewHistory}
      onRestore={onRestore}
      onApplyChanges={onApplyChanges}
    />
  );
}
